import { render, staticRenderFns } from "./PasswordResetSent.vue?vue&type=template&id=6bbbce82&scoped=true"
import script from "./PasswordResetSent.vue?vue&type=script&lang=js"
export * from "./PasswordResetSent.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetSent.vue?vue&type=style&index=0&id=6bbbce82&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbbce82",
  null
  
)

export default component.exports